<div class="timeline" [style.width.px]="width">
  <div class="timeline__header">
    <app-timeline-layer-add></app-timeline-layer-add>
    <app-timeline-buttons></app-timeline-buttons>
  </div>

  <div class="timeline__content">
    <div class="timeline__cursor"></div>

    <app-timeline-scale></app-timeline-scale>
    <app-timeline-layers></app-timeline-layers>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline.component.html